import type { ReactNode } from 'react';

/**
 * Belgilash katakchasi.
 *
 * Brauzerning standart katakchasi kichkina va OS'ga qarab boshqacha
 * ko'rinadi. Bu yerda haqiqiy `<input>` ekranda yashiriladi (fokus va
 * klaviatura ishlashi uchun DOM'da qoladi), ustiga o'zimizning katakcha
 * chiziladi.
 */

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: ReactNode;
  disabled?: boolean;
}

export function Checkbox({ checked, onChange, children, disabled }: CheckboxProps) {
  return (
    <label className={`checkbox ${disabled ? 'is-disabled' : ''}`}>
      <input
        type="checkbox"
        className="checkbox__input"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="checkbox__box" aria-hidden="true">
        <svg viewBox="0 0 16 16" width="12" height="12">
          <path
            d="M2.5 8.5l3.5 3.5L13.5 4.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <span className="checkbox__text">{children}</span>
    </label>
  );
}
